
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/accounts",
      function () {
        return require("private-next-pages/accounts.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/accounts"])
      });
    }
  